import { getIdTokenResult } from "firebase/auth";

/**
 * Check whether a Firebase user carries the `admin: true` custom claim.
 * UX gate only — Firestore security rules are the real enforcement.
 */
export async function userIsAdmin(user) {
  if (!user) return false;
  try {
    const { claims } = await getIdTokenResult(user);
    return claims.admin === true;
  } catch {
    return false;
  }
}
